<template>
  <div>
    <div
      class="card announcement-card"
      v-for="(announcement, index) in listingData"
      :key="index"
    >
      <div class="date">
        {{ announcement.Date }}
      </div>
      <a class="title" :href="announcement.LinkToDetails">
        {{ announcement.Title }}
      </a>
      <div class="description">
        {{ announcement.Brief }}
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: {
    AnnouncementArr: {
      type: Array,
    },
  },
  methods: {},
  computed: {
    listingData() {
      let lang = "ar";
      if (location.pathname.includes("/en")) {
        lang = "en";
      }
      let listingArray = JSON.parse(JSON.stringify(this.AnnouncementArr));
      listingArray.map((x) => {
        x.Date = moment(new Date(x.Date))
          .locale(lang)
          .format("DD - MMM - YYYY");
      });
      return listingArray;
    },
  },
  mounted() {},
};
</script>
